<!-- SUBSCRIPTION DETAILS -->
<ng-container *apSecure='[Permissions.ACCESS_ALL_SUBSCRIPTIONS]'>
  @if (subscription) {
    <ap-panel>
      <ap-panel-content>
        <div class='form-horizontal form-label-left'>
          <!-- SUBSCRIPTION DETAILS -->
          <div class='row subscription-details-container'>
            <!-- GENERAL INFORMATIONS TITLE -->
            <div class='col-sm-12 col-md-12 col-xs-12'>
              <span class='section panel-role-title' [ngClass]="{ 'user-view': userView }">
                {{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.TITLE' | translate }}
              </span>
            </div>
            <!-- GENERAL INFORMATIONS -->
            <div class='col-sm-6 col-md-6 col-xs-6'>
              <!-- SUBSCRIPTION ID  -->
              <div class='form-group'>
                <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SUBSCRIPTION.SUBSCRIPTION_ID' | translate }}</label>
                @if (subscription?.subscriptionId) {
                  <div class='col-sm-6 col-md-6 col-xs-6'><code>{{ subscription.subscriptionId }}</code></div>
                }
                @if (!subscription?.subscriptionId) {
                  <div class='col-sm-6 col-md-6 col-xs-6'>-</div>
                }
              </div>
              <!-- SUBSCRIPTION EXTERNAL REFERENCE -->
              @if (subscription?.externalReference) {
                <div class='form-group'>
                  <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SUBSCRIPTION.SUBSCRIPTION_EXTERNAL_REFERENCE' | translate }}</label>
                  <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription.externalReference | noData }}</div>
                </div>
              }
              <!-- SUBSCRIPTION STATUS -->
              <div class='form-group'>
                <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SUBSCRIPTION.SUBSCRIPTION_STATUS' | translate }}</label>
                @if (subscription?.status) {
                  <div class='col-sm-6 col-md-6 col-xs-6'><status-label [status]='subscription.status' type='SUBSCRIPTION'></status-label>@if (canShowPenIcon) {
                  <button (click)='openPlannedChangeStatusDialog()' class='btn btn-xs btn-default edit-button-dialog'><i class='fa fa-pencil'></i></button>
                }</div>
              }
              @if (!subscription?.status) {
                <div class='col-sm-6 col-md-6 col-xs-6'>-</div>
              }
            </div>
            <!-- SUBSCRIPTION CREATION DATE -->
            <div class='form-group'>
              <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SUBSCRIPTION.SUBSCRIPTION_CREATION_DATE' | translate }}</label>
              <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription?.creationDate | date: "dd/MM/yyyy 'à' HH:mm" | noData }}</div>
            </div>
            <!-- SUBSCRIPTION MODIFICATION DATE -->
            <div class='form-group'>
              <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SUBSCRIPTION.SUBSCRIPTION_MODIFICATION_DATE' | translate }}</label>
              <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription?.modificationDate | date: "dd/MM/yyyy 'à' HH:mm" | noData }}</div>
            </div>
            <!-- SUBSCRIPTION START VALIDITY DATE -->
            <div class='form-group'>
              <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SUBSCRIPTION.SUBSCRIPTION_START_VALIDITY_DATE' | translate }}</label>
              <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription?.startValidityDate | date: "dd/MM/yyyy 'à' HH:mm" | noData }}</div>
            </div>
            <!-- SUBSCRIPTION EXPIRATION DATE -->
            <div class='form-group'>
              <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SUBSCRIPTION.SUBSCRIPTION_EXPIRATION_DATE' | translate }}</label>
              <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription?.expirationDate | date: "dd/MM/yyyy 'à' HH:mm" | noData }}</div>
            </div>
            <!-- DATA RETENTION CONSENT -->
            <div class='form-group'>
              <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SUBSCRIPTION.DATA_RETENTION_CONSENT' | translate }}</label>
              <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription?.subscriptionDataRetentionConsent?.approved | yesno | noData }}</div>
            </div>
            <!-- TACIT RENEWAL -->
            <div class='form-group'>
              <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SUBSCRIPTION.TACIT_RENEWAL' | translate }}</label>
              <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription?.tacitRenewalApproved | yesno | noData }}</div>
            </div>
          </div>
          <!-- SERVICE OFFER, SERVICES AND OUTSTANDING INFORMATIONS  -->
          <div class='col-sm-6 col-md-6 col-xs-6'>
            <!-- SUBSCRIBED SERVICE OFFER -->
            <div class='form-group'>
              <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SERVICE_OFFER_AND_OUTSTANDING.SERVICE_OFFER' | translate }}</label>
              <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription?.serviceOfferName | noData }}</div>
            </div>
            <!-- SUBSCRIBED SERVICES -->
            <div class='form-group'>
              <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SERVICE_OFFER_AND_OUTSTANDING.SUBSCRIBED_SERVICES' | translate }}</label>
              @if (!subscription || !subscription.subscribedServices || subscription.subscribedServices.length == 0) {
                <div class='col-sm-6 col-md-6 col-xs-6'>-</div>
              } @else {
                <div class='col-sm-6 col-md-6 col-xs-6'>
                  @for (service of subscription.subscribedServices; track service) {
                    <span> {{ service.serviceName }} <br/> </span>
                  }
                </div>
              }
            </div>
            <!-- PAYMENT MODE -->
            <div class='form-group'>
              <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SERVICE_OFFER_AND_OUTSTANDING.PAYMENT_MODE' | translate }}</label>
              <div class='col-sm-6 col-md-6 col-xs-6'>{{ 'STATUS.SUBSCRIPTION.PAYMENT_MODE.' + subscription?.paymentMode | translateIfExist: subscription?.paymentMode | noData }}</div>
            </div>
            <!-- CURRENT MONTH OUTSTANDING AMOUNT TOTAL -->
            <ng-container *apSecure='[Permissions.ACCESS_ALL_ACTIVITIES]'>
              @if (PaymentMode.POSTPAYMENT === subscription.paymentMode && monthActivities !== null) {
                <div class='form-group'>
                  <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SERVICE_OFFER_AND_OUTSTANDING.MONTH_ACTIVITIES' | translate }}</label>
                  <div class='col-sm-6 col-md-6 col-xs-6'>{{ monthActivities | apCurrency }}</div>
                </div>
              }
            </ng-container>
            @if (PaymentMode.PREPAYMENT === subscription.paymentMode) {
              <div class='form-group'>
                <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SERVICE_OFFER_AND_OUTSTANDING.MONTH_ACTIVITIES' | translate }}</label>
                <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription?.standardPrice | apCurrency | noData }}</div>
              </div>
            }
            <!-- OUTSTANDING BEGIN DATE -->
            <div class='form-group'>
              <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SERVICE_OFFER_AND_OUTSTANDING.OUTSTANDING_BEGIN_DATE' | translate }}</label>
              <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription?.billingPeriodStartDate | date: "dd/MM/yyyy 'à' HH:mm" | noData }}</div>
            </div>
            <!-- OUTSTANDING END DATE -->
            <div class='form-group'>
              <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SERVICE_OFFER_AND_OUTSTANDING.OUTSTANDING_END_DATE' | translate }}</label>
              <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription?.billingPeriodEndDate | date: "dd/MM/yyyy 'à' HH:mm" | noData }}</div>
            </div>
            <!-- BILLING DATE -->
            <div class='form-group'>
              <label class='col-sm-6 col-md-6 col-xs-6'>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.SERVICE_OFFER_AND_OUTSTANDING.BILLING_DATE' | translate }}</label>
              <div class='col-sm-6 col-md-6 col-xs-6'>{{ subscription?.scheduledBillingDate | date: "dd/MM/yyyy 'à' HH:mm" | noData }}</div>
            </div>
          </div>
        </div>
      </div>
    </ap-panel-content>
  </ap-panel>
}
</ng-container>

<!-- SUBSCRIPTION STATUSES HISTORY -->
<ap-subscription-status-history-panel [subscription]='subscription' [canUpdateSubscriptionActive]='canUpdateSubscriptionActive' [canUpdateSubscriptionTerminated]='canUpdateSubscriptionTerminated'></ap-subscription-status-history-panel>

<!-- SUBSCRIPTION HOLDER / PAYER -->
<ap-subscription-holder-payer-panel [subscription]='subscription' [userView]='userView' [isPayer]='isPayer'></ap-subscription-holder-payer-panel>

<!-- INVOICES -->
<ap-invoices-panel [invoices]='invoices' [subscription]='subscription'></ap-invoices-panel>

<!-- NO DATA -->
@if (!subscription && !invoices) {
  <ap-panel>
    <ap-panel-title>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.GENERAL_INFORMATIONS.TITLE' | translate }}</ap-panel-title>
    <ap-panel-content>
      <ap-jumbotron [icon]="'fa-inbox'">{{ 'COMMON.ERROR.EMPTY_DATA' | translate }}</ap-jumbotron>
    </ap-panel-content>
  </ap-panel>
}
